const data = {
  "Basic Courses": [
    [
      "ADCA",
      "DCA",
      "Tally",
      "Typing",
      "Photoshop",
      "Corel Draw",
      "Web Designing Figma/PS",
    ],
  ],
  "Core Languages": [
    ["C", "C++", "Java", "Python", "PHP", "HTML"],
    ["JavaScript", "C Sharp", "TypeScript", "AWS", "WordPress", "CSS"],
  ],
  "Database Query": [
    [
      "SQL",
      "PL/SQL (Oracle)",
      "T-SQL (Microsoft SQL Server)",
      "MongoDB",
      "DBMS",
    ],
  ],
  "Full Stack Development": [
    ["HTML", "CSS++", "React JS", "Node JS", "Express JS", "MongoDB"],
    [
      "Java (Android)",
      "React Native (JavaScript)",
      "Flutter (Dart)",
      "Swift (iOS)",
      "Kotlin (Android)",
    ],
  ],
  "Data Science": [
    [
      "Introduction to Data Science",
      "Programming for Data Science",
      "Mathematics and Statistics for Data Science",
      "Data Wrangling and Cleaning",
      "Exploratory Data Analysis (EDA)",
      "Machine Learning Algorithms",
      "Advanced Machine Learning",
      "Big Data Technologies",
      "Data Science Tools",
      "Project and Case Studies",
    ],
    ["Python", "R", "SQL", "Java", "Scala", "Julia", "MATLAB"],
  ],
  "Machine Learning": [
    [
      "Introduction to Machine Learning",
      "Data Preprocessing",
      "Supervised Learning Algorithms",
      "Unsupervised Learning Algorithms",
      "Evaluation Metrics",
      "Model Improvement Techniques",
      "Neural Networks and Deep Learning",
      "Reinforcement Learning Basics",
      "Practical Tools and Frameworks",
    ],
    ["Python", "R", "Java", "C++", "Julia", "MATLAB"],
    [
      "Tools & Libraries",
      "TensorFlow",
      "Keras",
      "PyTorch",
      "Scikit-learn",
      "Pandas",
      "NumPy",
    ],
  ],
};

export default data;
